import {
    ILayoutActionTypes,
    ISetLayoutAction,
    ISetHeightAction,
    UpdateLayoutRequestActionType,
    UpdateLayoutSuccessActionType,
    UpdateLayoutFailureActionType,
    AddFieldToLayoutActionType,
    ReplaceFieldInLayoutActionType,
    DuplicateFieldToLayoutActionType,
    RefreshLayoutActionType,
    DeleteFieldFromLayoutActionType,
} from "./types";
import { ActionCreator } from "../types/store-types";

export const initLayout: ActionCreator<ISetLayoutAction> = payload => ({
    type: ILayoutActionTypes.INIT_LAYOUT,
    payload,
});

export const setHeight: ActionCreator<ISetHeightAction> = payload => ({
    type: ILayoutActionTypes.SET_HEIGHT,
    payload,
});

export const refreshLayout: ActionCreator<RefreshLayoutActionType> = payload => ({
    type: ILayoutActionTypes.REFRESH_LAYOUT,
    payload,
});

export const addFieldToLayout: ActionCreator<AddFieldToLayoutActionType> = payload => ({
    type: ILayoutActionTypes.ADD_FIELD_TO_LAYOUT,
    payload,
});

export const replaceFieldInLayout: ActionCreator<ReplaceFieldInLayoutActionType> = payload => ({
    type: ILayoutActionTypes.REPLACE_FIELD_IN_LAYOUT,
    payload,
});

export const deleteFieldFromLayout: ActionCreator<DeleteFieldFromLayoutActionType> = payload => ({
    type: ILayoutActionTypes.DELETE_FIELD_FROM_LAYOUT,
    payload,
});

/* -- Duplicate Layout -- */

export const duplicateFieldToLayout: ActionCreator<DuplicateFieldToLayoutActionType> = payload => ({
    type: ILayoutActionTypes.DUPLICATE_FIELD_TO_LAYOUT,
    payload,
});

/* -- Update Layout Request Type -- */

export const updateLayoutRequest: ActionCreator<UpdateLayoutRequestActionType> = payload => ({
    type: ILayoutActionTypes.UPDATE_LAYOUT_REQUEST,
    payload,
});

export const updateLayoutSuccess: ActionCreator<UpdateLayoutSuccessActionType> = payload => ({
    type: ILayoutActionTypes.UPDATE_LAYOUT_SUCCESS,
    payload,
});

export const updateLayoutFailure: ActionCreator<UpdateLayoutFailureActionType> = payload => ({
    type: ILayoutActionTypes.UPDATE_LAYOUT_FAILURE,
    payload,
});
